export const NEW_LEGAL_ENTITY_SUCCESS = 'NEW_LEGAL_ENTITY_SUCCESS';
export const CREATE_LEGAL_ENTITY_SUCCESS = 'CREATE_LEGAL_ENTITY_SUCCESS';
export const LIST_LEGAL_ENTITY_SUCCESS = 'LIST_LEGAL_ENTITY_SUCCESS';
export const EDIT_LEGAL_ENTITY_SUCCESS = 'EDIT_LEGAL_ENTITY_SUCCESS';
export const UPDATE_LEGAL_ENTITY_SUCCESS = 'UPDATE_LEGAL_ENTITY_SUCCESS';
export const DELETE_LEGAL_ENTITY_SUCCESS = 'DELETE_LEGAL_ENTITY_SUCCESS';
